var React = require('react');
var helpers = require('svg-react-loader/helpers')(require('react-dom'));

module.exports = React.createClass({

    displayName: "Apply",

    getDefaultProps () {
        return {"0":"{","1":"s","2":"t","3":"y","4":"l","5":"e","6":":","7":"{","8":"}","9":"}","width":"200","height":"200","viewBox":"0 0 200 200","version":"1.1","xmlns":"http://www.w3.org/2000/svg","data-svgreactloader":"[[\"http://www.w3.org/2000/svg\",\"xlink\",\"http://www.w3.org/1999/xlink\"]]"};
    },

    componentDidMount () {
        helpers.applyXmlAttributes(this);
    },

    render () {
        var props = this.props;
        var children = props.children;

        return (
            <svg {...this.props}>
                  <defs>
    <style type="text/css">{`
@font-face { font-family: ifont; src: url(\"http://at.alicdn.com/t/font_1442373896_4754455.eot?#iefix\") format(\"embedded-opentype\"), url(\"http://at.alicdn.com/t/font_1442373896_4754455.woff\") format(\"woff\"), url(\"http://at.alicdn.com/t/font_1442373896_4754455.ttf\") format(\"truetype\"), url(\"http://at.alicdn.com/t/font_1442373896_4754455.svg#ifont\") format(\"svg\"); }

`}</style>
  </defs>
  <g className="transform-group">
    <g transform="scale(0.1953125, 0.1953125)">
      <path d="M190.231087 546.83539l155.550729-78.723969c0 0 139.522684 166.099992 161.116491 408.477228l-119.148657 51.347458C387.74965 927.936107 228.564138 744.602615 190.231087 546.83539zM412.607804 942.581666 514.345929 903.82292 494.96758 991.021911ZM1019.738441 900.454196 1019.738441 124.669394c0-87.942935-61.703317-113.511263-95.000678-114.752534L67.67789 9.91686l0 1.702782C61.596382 12.346189 55.479057 13.551644 49.292148 15.804964-79.645456 62.524009 112.44856 456.161251 182.341397 526.125719l155.142429-78.29725c0 0-75.337849-297.626561-185.976692-401.599587l772.556271-0.01842c2.411933 0.089028 59.363016 3.121084 59.363016 78.45791l0.033769 776.776386c0 0.355087 1.347694 38.157042-22.198581 62.980403-14.607696 15.424294-36.489052 23.260773-65.035202 23.260773L153.494395 987.685933c-3.670599 0-90.000803-1.028423-90.000803-90.177835L63.493591 733.572398 27.180548 733.572398l0 163.936723c0 100.036367 82.624812 126.489856 126.312824 126.489856l742.733035 0c38.900985 0 69.647243-11.631922 91.419106-34.609239C1022.184143 952.936501 1019.843842 901.659651 1019.738441 900.454196zM576.439126 263.820618l296.52446 0 0 72.625064-296.52446 0 0-72.625064ZM434.186262 445.38072l435.764712 0 0 69.610404-435.764712 0 0-69.610404ZM582.4664 660.240229l284.46889 0 0 75.637678-284.46889 0 0-75.637678Z" fill="#272636"/>
    </g>
  </g>
                {React.Children.map(children, (c) => (c))}
            </svg>
        );
    }
});



/** WEBPACK FOOTER **
 ** ./demo/src/svg/apply.svg
 **/